import * as Yup from 'yup';

export const requiredNameWithMaxLength = Yup.string()
  .required('Name Required')
  .min(1)
  .max(100);
export const requiredLabel = Yup.string().required('Prep Area Required');
export const requiredStatus = Yup.string().required('Status Required');
export const requiredType = Yup.string().required('Type is required');
export const requiredOptionsPrice = Yup.number().required(
  'Options price field cannot be blank'
);
export const requiredParentId = Yup.string().required('Parent ID is required');

export const costPriceValidation = Yup.number()
  .min(0, 'Cost price cannot be negative')
  .when('price', (price, schema) => {
    if (price != null && price > 0) {
      return schema.test(
        'is-less-than-or-equal-price',
        'Cost price cannot be greater than the selling price',
        value => value == null || value <= price
      );
    }
    return schema;
  });

export const vatRateValidation = Yup.number()
  .min(0, 'VAT rate cannot be negative')
  .max(1, 'VAT rate cannot exceed 100%')
  .nullable()
  .test(
    'both-or-neither',
    'Both eat-in and takeaway VAT rates must be set together, or both left empty',
    function (value) {
      const { vat_rate_eat_in, vat_rate_takeaway } = this.parent;
      const eitherSet = vat_rate_eat_in != null || vat_rate_takeaway != null;
      const bothSet = vat_rate_eat_in != null && vat_rate_takeaway != null;
      return !eitherSet || bothSet;
    }
  );



// WEBPACK FOOTER //
// ./src/components/Dashboard/Panels/MenuEditor/utils/validation.js